<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4251"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4255"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4317"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4315" /></clipPath></defs><g
     id="g4257"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4259"
       transform="translate(323.0376,419.2617)"><path
         d="M 0,0 H -150.488 M -194.82,35.292 H 44.333"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4261" /></g><g
       id="g4263"
       transform="translate(128.2173,351.627)"><path
         d="M 0,0 18.765,-15.902 54.112,26.277"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4265" /></g><g
       id="g4267"
       transform="translate(128.2173,280.0518)"><path
         d="M 0,0 18.765,-15.902 54.112,26.277"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4269" /></g><g
       id="g4271"
       transform="translate(128.2173,208.4766)"><path
         d="M 0,0 18.765,-15.902 54.112,26.277"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4273" /></g><g
       id="g4275"
       transform="translate(128.2173,136.9307)"><path
         d="M 0,0 18.765,-15.931 54.112,26.277"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4277" /></g><g
       id="g4279"
       transform="translate(306.3706,339.1543)"><path
         d="M 0,0 H -85.434"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4281" /></g><g
       id="g4283"
       transform="translate(278.0249,374.4746)"><path
         d="M 0,0 H 88.694 M -57.088,0 h 21.627"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4285" /></g><g
       id="g4287"
       transform="translate(306.3706,267.5791)"><path
         d="M 0,0 H -85.434"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4289" /></g><g
       id="g4291"
       transform="translate(220.9365,231.3242)"><path
         d="M 0,0 H 145.782"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4293" /></g><g
       id="g4295"
       transform="translate(288.0591,124.4297)"><path
         d="M 0,0 H -67.123"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4297" /></g><g
       id="g4299"
       transform="translate(309.6587,302.8994)"><path
         d="M 0,0 H -88.722 M 57.06,0 H 35.432"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4301" /></g><g
       id="g4303"
       transform="translate(238.7939,196.0049)"><path
         d="M 0,0 H -17.857 M 67.577,0 H 26.588"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4305" /></g><g
       id="g4307"
       transform="translate(318.9844,159.749)"><path
         d="M 0,0 H -98.048"
         style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4309" /></g><g
       id="g4311"><g
         id="g4313"
         clip-path="url(#clipPath4317)"><g
           id="g4319"
           transform="translate(413.9146,309.5605)"><path
             d="m 0,0 v -163.928 m -84.301,-74.58 h -237.481 c -5.754,0 -10.459,4.706 -10.459,10.488 v 412.499 c 0,5.755 4.705,10.46 10.459,10.46 H -10.46 c 5.754,0 10.46,-4.705 10.46,-10.46 L 0,34.611"
             style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4321" /></g><g
           id="g4323"
           transform="translate(42.9814,239.1768)"><path
             d="m 0,0 v 216.17 c 0,5.755 4.706,10.46 10.459,10.46 H 38.692 M 298.85,-206.816 H 10.459 C 4.706,-206.816 0,-202.083 0,-196.328 V -34.64"
             style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4325" /></g><g
           id="g4327"
           transform="translate(377.2915,73.8135)"><path
             d="m 0,0 15.023,-13.266 28.29,35.121"
             style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4329" /></g><g
           id="g4331"
           transform="translate(469.0186,77.3457)"><path
             d="m 0,0 c 0,33.506 -23.612,61.513 -55.104,68.287 -4.734,1.021 -9.694,1.559 -14.74,1.559 -38.579,0 -69.844,-31.266 -69.844,-69.846 0,-2.126 0.085,-4.224 0.283,-6.293 1.304,-14.655 7.144,-28.034 16.129,-38.692 12.813,-15.195 32.003,-24.861 53.432,-24.861 C -31.266,-69.846 0,-38.579 0,0 Z"
             style="stroke:#000000;stroke-width:15.118;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4333" /></g></g></g></g></svg>
</template>
